import type { CustomWeb3Provider, OrderTransaction, PageResult } from '$lib/types';
import type { AxiosInstance } from 'axios';
import { getDefaultAxios } from './AxiosService';

export class TransactionService {
	transactionsURL = `/markets/transactions`;
	axios: AxiosInstance;

	constructor() {
		this.axios = getDefaultAxios();
	}

	async getTokenTransationHistory(tokenId: string) {
		const resp = await this.axios.get<PageResult<OrderTransaction>>(this.transactionsURL, {
			headers: {
				'Content-Type': 'application/json'
			},
			params: {
				tokenId
			}
		});
		return resp.data.data;
	}

	async getUserTransationHistory(address: string) {
		const resp = await this.axios.get<PageResult<OrderTransaction>>(this.transactionsURL, {
			headers: {
				'Content-Type': 'application/json'
			},
			params: {
				address
			}
		});
		// FIXME why return null here
		if (!resp.data.data) {
			return [];
		}
		return resp.data.data;
	}
}

export function buyOrSell(from: string, to: string, userAddress: string, isOffer: boolean) {
	if (from.toLowerCase() === userAddress.toLowerCase()) {
		return 'Sell' ;
	}

	if (to.toLowerCase() === userAddress.toLowerCase()) {
		return 'Buy';
	}

	return 'Buy';
}
